import React from 'react'
import PropTypes from 'prop-types'
import SectionItem from '@v4/components/common/SectionItem'
import FlipMove from 'react-flip-move'
import PageDivider from '@v4/components/common/PageDivider'
import EmptyMainSection from '../EmptyMainSection'
import { useSectionList } from './SectionList.hooks'

const SectionList = props => {
	const [
		{ activeSectionId, collection, sectionIds, sectionsMap, duration, withAddition, isMainSectionEmpty, pageType },
		{ handleFinish, handleAdd },
	] = useSectionList(props)

	return isMainSectionEmpty ? (
		<EmptyMainSection pageType={pageType} />
	) : (
		<>
			<FlipMove duration={duration} typeName={null} onFinish={handleFinish} onStart={handleFinish}>
				{_.map(sectionIds, ({ id, index: additionIndex }, index) => (
					<SectionItem
						id={id}
						key={id}
						collection={collection}
						active={id === activeSectionId}
						index={index}
						additionIndex={additionIndex}
						sectionsMap={sectionsMap}
						first={!index}
						last={index === sectionIds.length - 1}
					/>
				))}
			</FlipMove>
			{withAddition && <PageDivider onClick={handleAdd} />}
		</>
	)
}

SectionList.propTypes = {
	collection: PropTypes.string.isRequired,
	sectionsMap: PropTypes.object.isRequired,
}

export default SectionList
